const Tour = require('component/tour/index.js');
const config = require('./config.yaml');

function initAnalysis(callback) {
	require.ensure(['zebra-analysis'], function (require) {
		const ZebraAnalysis = require('zebra-analysis');
		const zebraAnalysis = new ZebraAnalysis(config, 'analysis', templateVars.lang);
		zebraAnalysis.init()
			.then(function () {
				global.zebraAnalysis = zebraAnalysis;
				callback();
				// const tour = new Tour(require('./tourConfig.js')());
				// tour.startFirstTime();
			});
	});
}

if (document.getElementById('analysis')) {
	initAnalysis(function () {
		global.updateAccordionsSelectors();

		if (window.location.hash) {
			global.checkAccordionsHash();
		}
	});
}



// WEBPACK FOOTER //
// ./temp/components/analysis/index.js